export default __webpack_public_path__ + "assets/images/decor.6c6381.webp";